import styled from "styled-components";
import MUIMenu from "@mui/material/Menu";

export const StyledAccountMenu = styled(MUIMenu).attrs(() => ({
    elevation: 0,
}))`
    .accountInfoItem {
        &.disabled {
            position: relative;
            pointer-events: none;
            cursor: default;
            opacity: 0.5;
        }

        &.disabled::before {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            pointer-events: auto;
            content: "";
        }

        svg {
            path {
                fill: var(--color-secondary);
            }
        }
    }

    button {
        width: 95%;
        margin: 0.8rem auto;
    }

    .broker-avatar {
        img {
            object-fit: contain;
        }

        margin-right: 16px;
    }

    .menu-paper {
        min-width: 312px;
        max-width: 312px;
        border: none;
        max-height: "calc(90% - 96px)";
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15) !important;

        .menu-list {
            .menuitem-root {
                padding: 10px 20px;
                /* border-bottom: 2px solid var(--color-grey-500); MYBR-6930 */

                &:last-child {
                    border: none;
                }

                .menuitem-icon-root {
                    min-width: 4rem;
                }

                .menuitem-text-root {
                    font-size: var(--size-18);
                    font-style: normal;
                    font-weight: var(--weight-600);
                    line-height: 25px;
                    color: var(--color-grey-900);
                    white-space: normal;
                }

                i {
                    min-width: 30px;
                    text-align: right;
                }
            }
        }
    }
`;
